import { render } from "./InspecaoSecao5.vue?vue&type=template&id=8d6795e8&scoped=true&ts=true"
import script from "./InspecaoSecao5.vue?vue&type=script&lang=ts"
export * from "./InspecaoSecao5.vue?vue&type=script&lang=ts"

import "./InspecaoSecao5.vue?vue&type=style&index=0&id=8d6795e8&scoped=true&lang=css"

import exportComponent from "D:\\RopeSeguros\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d6795e8"]])

export default __exports__